<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M6 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 6 4.75ZM6.75 9a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H6.75Zm0 5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Zm-3.28-2.22a.75.75 0 0 0 1.06-1.06l-.97-.97.97-.97a.75.75 0 0 0-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06l1.5 1.5Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 1 1 0 1h-8a.5.5 0 0 1-.5-.5ZM3.56 7.73a.5.5 0 0 1 .7.7L3.22 9.5l1.06 1.06a.5.5 0 1 1-.7.7l-1.42-1.4a.5.5 0 0 1 0-.71l1.41-1.42ZM6.5 9a.5.5 0 0 0 0 1h11a.5.5 0 1 0 0-1h-11ZM6 14.5c0-.28.22-.5.5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5Z"
    />
  </svg>
</template>
